import React, { useRef } from 'react';
import { Modal } from '@material-ui/core';
import { useOutsideClickAlerter } from '../hooks/useOutsideClickAlerter';
import { modalStyles } from '../styles/modal-styles';

interface Props {
    open: boolean;
    handleClose: () => any;
}

export const GenericModal = (props: React.PropsWithChildren<Props>) => {
    const innerModalRef = useRef(null);
    const classes = modalStyles();

    useOutsideClickAlerter(innerModalRef, props.handleClose);

    return (
        <Modal
            className={classes.modalWrapper}
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="admin-invite-modal-title"
            aria-describedby="admin-invite-modal-description"
        ><div className='modal-container'>
                <div className='modal-inner'>
                    <div className='modal-close'>
                        <button type='button' className='un-button modal-close-button' onClick={props.handleClose} >Close <svg className='info-icon' aria-hidden='true' focusable='false'>
                            <use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#close-icon' />
                        </svg></button>
                    </div>
                    <div className='modal-content'>
                        <div className='modal-content-inner' ref={innerModalRef}>
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};